import { ChangeEventHandler, FocusEventHandler, MouseEventHandler, ReactNode, useRef, useState } from 'react'
import { css } from '@emotion/react'
import { ON_TERTIARY_CONTAEINER_COLOR, PRIMARY_COLOR  } from "style"
import { IconContext } from "react-icons"

const height = '4rem'
const fontSize = '1.5rem'

const fieldStyle = css`
  display: flex;
`

const primeColor = css`
  color: ${PRIMARY_COLOR};
`

const primeFocusColor = css`
  &:focus{
    outline-color: ${PRIMARY_COLOR};
  }
`

const tertiaryColor = css`
  color: ${ON_TERTIARY_CONTAEINER_COLOR};
`

const tertiaryFocusColor = css`
  &:focus{
    outline-color: ${ON_TERTIARY_CONTAEINER_COLOR};
  }
`

const iconAreaBaseStyle = css`
  width: 3.5rem;
  height: ${height};
  font-size: 2rem;
  line-height: ${height};
  text-align: center;
`

const inputAreaBaseStyle = css`
  flex:1;
  display: grid;
  place-items: center;
`

const inputContainerBaseStyle = css`
  position: relative;
  width: 100%;
`

const labelStyle = css`
  position: absolute;
  color: #555;
  left: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: ${fontSize};
  transition: all 0.2s;
`

const smallCharBaseStyle = css`
  top: 0.5rem;
  font-size: 0.65rem;
  color: ${PRIMARY_COLOR};
  font-weight: bold;
`

const inputBaseStyle = css`
  display: block;
  border-width: 0;
  width: 100%;
  box-sizing:border-box;
  background-color: #eee;
  border-radius: 0.15rem;
  padding: 1rem 0.5rem 0.5rem 0.5rem;
  font-size: ${fontSize};
  color: #666;
`

type Props = {
  level?: string,
  type?: string,
  icon: ReactNode,
  placeholder: string,
  defaultValue?: string,
  value?: string,
  readOnly?: boolean,
  children?: ReactNode,
  onChange?: ChangeEventHandler<HTMLInputElement>
}

export const Field= ({
  readOnly = false , 
  type = 'text',
  level = 'primary',
  ...props}: Props)=>{

  const [isFocus, setIsFocus] = useState<boolean>(false)
  const [isFilled, setIsFilled] = useState<boolean>(!isLengthZeto(props.value) || !isLengthZeto(props.defaultValue))
  const labelCss = (isFilled || isFocus)? [labelStyle, smallCharBaseStyle] : labelStyle

  const inputElement = useRef<HTMLInputElement>(null)

  const colorStyle = 
    level === 'prime' ? primeColor :
    level === 'tertiary' ? tertiaryColor :
    primeColor
  
  const focusColorStyle = 
    level === 'prime' ? primeFocusColor :
    level === 'tertiary' ? tertiaryFocusColor :
    primeFocusColor

  const iconAreaStyle = [iconAreaBaseStyle, colorStyle]
  const inputStyle = [inputBaseStyle, focusColorStyle]

  //useMemo検討
  const onClick: MouseEventHandler = (evt) =>{
    evt.stopPropagation()
  }

  const onLableClick: MouseEventHandler<HTMLLabelElement> = (evt)=>{
    evt.stopPropagation()
    inputElement.current?.focus()
  }

  const onFocus: FocusEventHandler<HTMLInputElement> = (evt) =>{
    evt.stopPropagation()
    setIsFocus(true)
  }

  const onBlur: FocusEventHandler<HTMLInputElement> = (evt) =>{
    evt.stopPropagation()
    setIsFocus(false)
  }

  const onChange: ChangeEventHandler<HTMLInputElement> = (evt) =>{
    if(evt.target.value.length === 0){
      setIsFilled(()=>false)
    }else{
      setIsFilled(()=>true)
    }

    if(props.onChange){
      props.onChange(evt)
    }
  }

  return(
    <div data-testid="container" css={fieldStyle} onClick={onClick}>
      <div css={iconAreaStyle} >
        <IconContext.Provider value={{size: "1.5rem"}}>
          {props.icon}
        </IconContext.Provider>
      </div>
      <div css={inputAreaBaseStyle}>
        <div data-testid="input-container" css={inputContainerBaseStyle}>
          <input 
            data-testid="input"
            css ={inputStyle}
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={onChange}
            readOnly={readOnly}
            defaultValue={props.defaultValue}
            value={props.value}
            type={type}
            ref={inputElement}
          />
          <label data-testid="label" css={labelCss} onClick={onLableClick}>{props.placeholder}</label>
        </div>
      </div>
    </div>
  )
}

const isLengthZeto = (str? : string) : boolean =>{
  return [undefined, null, ""].includes(str)
}
